import React, { useEffect, useState } from "react";
import CrudForm from "../../components/dashboard/form/CrudForm";
import DashboardWrapper from "../../components/DashboardWrapper";
import { useSingletonCrud } from "../../hooks/useSingletonCrud";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
const LOCAL_STORAGE_KEY = "codSettingData";
export default function CashOnDeliveryPayment() {
  const navigate = useNavigate();
  const { loading, errors, fetchSingleton, updateSingleton } = useSingletonCrud(
    "backend/cod-setting" // ✅ API endpoint
  );
  const [initialData, setInitialData] = useState(null);
  // Fields allowed in this form
  const allowedFields = ["status"];
  useEffect(() => {
    // Load cached data
    const cached = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (cached) {
      try {
        setInitialData(JSON.parse(cached));
      } catch (e) {
        console.warn("Failed to parse cached COD data:", e);
      }
    }
    const fetchData = async () => {
      try {
        const codSetting = await fetchSingleton();
        const formatted = {
          status: codSetting?.status ? 1 : 0,
        };
        setInitialData(formatted);
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(formatted));
      } catch (error) {
        console.error("Error fetching COD data:", error);
        Swal.fire("Error", "Failed to load COD setting", "error");
      }
    };
    fetchData();
  }, []);
  const handleSubmit = async (formData) => {
    try {
      const dataToSend = {
        status: Number(formData.status) === 1, // ensure boolean
      };
      const res = await updateSingleton(dataToSend);
      Swal.fire("Success", "COD setting updated successfully", "success");
      const updatedData = {
        status: res.status ? 1 : 0,
      };
      setInitialData(updatedData);
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updatedData));
    } catch (error) {
      console.error("Error updating COD setting:", error);
      let msg = "Failed to update COD setting";
      if (error.response?.data) {
        if (error.response.data.errors) {
          msg = Object.values(error.response.data.errors).flat().join(", ");
        } else if (error.response.data.message) {
          msg = error.response.data.message;
        }
      }
      Swal.fire("Error", msg, "error");
    }
  };
  const shouldShowLoading = loading && !initialData;
  return (
    <DashboardWrapper>
      <div className="container-xxl flex-grow-1 p-4">
        <h1 className="h4">COD Payment Setting</h1>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <button
            className="btn btn-secondary d-flex align-items-center justify-content-between"
            onClick={() => navigate(-1)}
          >
            <i className="bx bx-arrow-back" style={{ marginTop: "2px" }}></i>
            <span>Back</span>
          </button>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">Manage COD Settings</div>
              <div className="card-body">
                {shouldShowLoading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: "200px" }}
                  >
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <>
                    <CrudForm
                      initialData={initialData || {}}
                      onSubmit={handleSubmit}
                      allowedFields={allowedFields}
                      customFields={{
                        status: {
                          label: "COD Status",
                          type: "select",
                          options: [
                            { value: 1, label: "Enabled" },
                            { value: 0, label: "Disabled" },
                          ],
                        },
                      }}
                    />
                    {errors.fetch && (
                      <div className="text-danger mt-2">
                        Error: {errors.fetch}
                      </div>
                    )}
                    {errors.update && (
                      <div className="text-danger mt-2">
                        Error: {errors.update}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardWrapper>
  );
}